import styled from 'styled-components';

// LE RIGHE DELLE SETTINGS, UNA LINGUA SOLA. Le usano la dialog e gli editor che ci stanno dentro:
// prima ognuno aveva la sua testata di sezione, e nella stessa finestra se ne vedevano due — una in
// maiuscoletto e una in grassetto sottolineato — a pochi pixel l'una dall'altra.

// La testata di una sezione, non un titolo di pagina: dice di quale famiglia sono le
// righe che seguono, e nel prototipo è scritta in maiuscoletto sopra la sua linea.
export const SettingsSectionTitle = styled.h3`
    margin: 0 0 4px;
    color: ${(props) => props.theme.app.primary};
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
`;

export const SettingsSection = styled.section`
    display: flex;
    flex-direction: column;
`;

// Etichetta e comando, niente di più: la riga di spiegazione sotto il nome non c'è nel
// prototipo, e su sei righe faceva della lista un documento da leggere.
export const SettingRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    min-height: 46px;
    padding: 8px 0;
    border-bottom: 1px solid ${(props) => props.theme.app.borderColor};

    &:last-child {
        border-bottom: 0;
    }
`;

export const SettingLabel = styled.label`
    color: ${(props) => props.theme.app.textColor};
    font-size: 13px;
`;

// Il comando si allarga quanto lo lasciano: senza una misura, in una riga che spinge
// i due capi agli estremi, sarebbe largo quanto gli pare al browser.
export const SettingControl = styled.div`
    width: 180px;
`;
